import { useEffect, useRef, useState } from 'react';
import { useLang } from '../i18n';

const brands = [
  { name: 'Flowmaster', color: '#D7261E' },
  { name: 'Magnaflow', color: '#1E4FBF' },
  { name: 'Borla', color: '#1A1A1A' },
  { name: 'Dynomax', color: '#D7261E' },
  { name: 'Cherry Bomb', color: '#C61F18' },
  { name: 'Gibson', color: '#1E4FBF' },
  { name: 'K&N', color: '#D7261E' },
  { name: 'AirAid', color: '#1E4FBF' },
  { name: 'MBRP', color: '#1A1A1A' },
];

export default function Brands() {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const { t } = useLang();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ background: '#fff' }} data-testid="brands-strip">
      <div className="sm-container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
        <div className="reveal-item" style={{ textAlign: 'center', marginBottom: '1.75rem', ...(visible ? { opacity: 1, transform: 'translateY(0)' } : {}) }}>
          <div className="section-label">{t.brandsLabel}</div>
          <p style={{ fontSize: '16px', color: 'var(--sm-muted)', margin: '0.25rem 0 0' }}>{t.brandsSubtitle}</p>
        </div>
        <div className="brands-row">
          {brands.map((brand, i) => (
            <div key={i} className="brand-item reveal-item" style={{ transitionDelay: `${i * 50}ms`, ...(visible ? { opacity: 1, transform: 'translateY(0)' } : {}), '--brand-hover-color': brand.color }}
              onMouseEnter={(e) => { e.currentTarget.style.color = brand.color; e.currentTarget.style.borderColor = brand.color; e.currentTarget.style.transform = 'scale(1.05)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = ''; e.currentTarget.style.borderColor = ''; e.currentTarget.style.transform = ''; }}
            >
              {brand.name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
